<div style="display: flex; flex-direction: column; max-height: 100%">
    <div fxFlex>
        <mat-toolbar color="primary">
            <mat-toolbar-row>
                <div fxShow="true" fxHide.lt-md fxFlex fxLayout>
                    <div fxFlex>
                        <span class="mat-h3">Organization's App Configurations</span>
                        <button mat-raised-button (click)="submit()" style="float: right">
                            {{ "GENERAL.save" | translate }}
                        </button>
                    </div>
                </div>
            </mat-toolbar-row>
        </mat-toolbar>
    </div>

    <div style="display: flex; flex-direction: row; height: 100%; overflow: hidden">
        <div style="display: flex; flex-grow: 1; flex-direction: column; overflow: hidden; max-height: 100%; height: auto">
            <kendo-grid [data]="appConfigKeys" style="border: none">
                @for (col of gridColumns; track $index) {
                    <kendo-grid-column
                        [headerStyle]="{
                            'white-space': 'break-spaces',
                            width: $first ? '200px' : '160px',
                        }"
                        [sticky]="$first"
                        [title]="col.title"
                        [field]="col.field"
                        [style]="{ width: $first ? '200px' : '160px' }"
                    >
                        <ng-template kendoGridCellTemplate let-type>
                            @if ($first) {
                                <div style="display: flex; gap: 10px; align-items: center">
                                    <span style="width: 180px">{{ type }}. {{ "APPCONFIG." + getEnumKeyByValue(type) + ".title" | translate }}</span>
                                    <mat-icon [matTooltip]="'APPCONFIG.' + getEnumKeyByValue(type) + '.description' | translate">info</mat-icon>
                                </div>
                            } @else {
                                @let appConfig = (col.field | pick: "appConfigs" | values | flatten | filterBy: ["type"] : type : true)[0];
                                <div style="display: flex; flex-direction: column; text-align: center; align-items: center">
                                    @if (
                                        type === appConfigType.plannedFlightsToAll ||
                                        type === appConfigType.planFlights ||
                                        type === appConfigType.directFlights ||
                                        type === appConfigType.autoLock
                                    ) {
                                        <mat-checkbox disabled [checked]="appConfig.enabled"></mat-checkbox>
                                    } @else if (
                                        type !== appConfigType.tabletOrientation &&
                                        type !== appConfigType.inactivityTime &&
                                        type !== appConfigType.passengers &&
                                        type !== appConfigType.crew &&
                                        type !== appConfigType.hooks
                                    ) {
                                        <mat-checkbox [(ngModel)]="appConfig.enabled" />
                                    }
                                    @switch (type) {
                                        @case (appConfigType.inactivityTime) {
                                            <div>
                                                <div style="display: flex">
                                                    <input
                                                        style="width: 32px; margin-right: 2px; text-align: center"
                                                        min="0"
                                                        max="59"
                                                        [(ngModel)]="appConfig.valueHours"
                                                        type="number"
                                                        (ngModelChange)="onInactivityValueChange(appConfig)"
                                                    />
                                                    &nbsp;:&nbsp;
                                                    <input
                                                        style="width: 48px; margin-right: 2px; text-align: center"
                                                        min="0"
                                                        max="59"
                                                        [(ngModel)]="appConfig.valueMinutes"
                                                        type="number"
                                                        (ngModelChange)="onInactivityValueChange(appConfig)"
                                                    />
                                                </div>
                                                <span>[ mm : ss]</span>
                                            </div>
                                        }
                                        @case (appConfigType.holdItemListWarnings) {
                                            <div style="display: flex; flex-direction: column; align-items: start">
                                                <strong>Thresholds</strong>
                                                <label>
                                                    Days
                                                    <input type="number" style="width: 48px" [(ngModel)]="appConfig.value.days" min="1" [disabled]="!appConfig.enabled" />
                                                </label>
                                                <label>
                                                    HH:MM
                                                    <input
                                                        type="text"
                                                        style="width: 80px"
                                                        [(ngModel)]="appConfig.value.hours"
                                                        [pattern]="HOURS_PATTERN"
                                                        [disabled]="!appConfig.enabled"
                                                    />
                                                </label>
                                                <label>
                                                    Cycles
                                                    <input type="number" style="width: 48px" [(ngModel)]="appConfig.value.cycles" min="1" [disabled]="!appConfig.enabled" />
                                                </label>
                                                <label>
                                                    FN
                                                    <input type="number" style="width: 48px" [(ngModel)]="appConfig.value.flightNumber" min="1" [disabled]="!appConfig.enabled" />
                                                </label>
                                                <div>
                                                    Pilot
                                                    <mat-checkbox
                                                        [disabled]="!appConfig.enabled"
                                                        [(ngModel)]="appConfig.value.pilot"
                                                        (change)="onPilotCheckboxChange($event, appConfig)"
                                                    >
                                                    </mat-checkbox>
                                                </div>
                                                <div>
                                                    Can Update
                                                    <mat-slide-toggle
                                                        [disabled]="!appConfig.enabled || !appConfig.value.pilot"
                                                        [ngModel]="appConfig.value?.pilot?.canUpdate"
                                                        (change)="onPilotSubSwitchChange($event, appConfig, 1)"
                                                    >
                                                    </mat-slide-toggle>
                                                </div>
                                                <div>
                                                    Can Close
                                                    <mat-slide-toggle
                                                        [disabled]="!appConfig.enabled || !appConfig.value.pilot"
                                                        [ngModel]="appConfig.value?.pilot?.canClose"
                                                        (change)="onPilotSubSwitchChange($event, appConfig, 2)"
                                                    >
                                                    </mat-slide-toggle>
                                                </div>
                                            </div>
                                        }
                                        @case (appConfigType.shortFrequencyWarnings) {
                                            <div style="display: flex; flex-direction: column; align-items: start">
                                                <div>
                                                    Show Tolerance
                                                    <mat-slide-toggle [disabled]="!appConfig.enabled" [(ngModel)]="appConfig.value.tolerance" />
                                                </div>
                                                <div>
                                                    Reference text field
                                                    <mat-slide-toggle [disabled]="!appConfig.enabled" [(ngModel)]="appConfig.value.reference" />
                                                </div>
                                                <strong>Thresholds</strong>
                                                <label>
                                                    Days
                                                    <input type="number" style="width: 48px" [(ngModel)]="appConfig.value.days" min="1" [disabled]="!appConfig.enabled" />
                                                </label>
                                                <label>
                                                    HH:MM
                                                    <input
                                                        type="text"
                                                        style="width: 80px"
                                                        [(ngModel)]="appConfig.value.hours"
                                                        [pattern]="HOURS_PATTERN"
                                                        [disabled]="!appConfig.enabled"
                                                    />
                                                </label>
                                                <label>
                                                    Cycles
                                                    <input type="number" style="width: 48px" [(ngModel)]="appConfig.value.cycles" min="1" [disabled]="!appConfig.enabled" />
                                                </label>
                                                <label>
                                                    FN
                                                    <input type="number" style="width: 48px" [(ngModel)]="appConfig.value.flightNumber" min="1" [disabled]="!appConfig.enabled" />
                                                </label>
                                            </div>
                                        }
                                        @case (appConfigType.nextScheduleWarning) {
                                            <div style="display: flex; flex-direction: column; align-items: start">
                                                <strong>Thresholds</strong>
                                                <label>
                                                    Days
                                                    <input type="number" style="width: 48px" [(ngModel)]="appConfig.value.days" min="1" [disabled]="!appConfig.enabled" />
                                                </label>
                                                <label>
                                                    HH:MM
                                                    <input
                                                        type="text"
                                                        style="width: 80px"
                                                        [(ngModel)]="appConfig.value.hours"
                                                        [pattern]="HOURS_PATTERN"
                                                        [disabled]="!appConfig.enabled"
                                                    />
                                                </label>
                                            </div>
                                        }
                                        @case (appConfigType.dailyCheck) {
                                            <div style="display: flex; flex-direction: column; align-items: start">
                                                <strong>Threshold</strong>
                                                <label>
                                                    HH:MM
                                                    <input
                                                        type="text"
                                                        style="width: 80px"
                                                        [(ngModel)]="appConfig.value.hours"
                                                        [pattern]="HOURS_PATTERN"
                                                        [disabled]="!appConfig.enabled"
                                                    />
                                                </label>
                                            </div>
                                        }
                                        @case (appConfigType.engineWarmUpCoolDownTimeBuffer) {
                                            <div><input type="number" style="width: 32px" [(ngModel)]="appConfig.value" min="0" />(min)</div>
                                        }
                                        @case (appConfigType.tabletOrientation) {
                                            <select [(ngModel)]="appConfig.value">
                                                <option value="landscape">
                                                    {{ "APPCONFIG.landscape" | translate }}
                                                </option>
                                                <option value="portrait">
                                                    {{ "APPCONFIG.portrait" | translate }}
                                                </option>
                                            </select>
                                        }
                                        @case (appConfigType.passengers) {
                                            <div style="display: flex; gap: 4px; flex-direction: column">
                                                <div>
                                                    Enabled
                                                    <mat-checkbox [(ngModel)]="appConfig.enabled" />
                                                </div>
                                                <div>
                                                    Add paying Passengers
                                                    <mat-slide-toggle
                                                        [disabled]="!appConfig.enabled"
                                                        [(ngModel)]="appConfig.valueFirst"
                                                        (ngModelChange)="onPassengersValueChange(appConfig)"
                                                    />
                                                </div>
                                                <div style="display: flex; gap: 4px">
                                                    <input
                                                        type="number"
                                                        [disabled]="appConfig.valueFirst == 0"
                                                        style="width: 64px; text-align: center"
                                                        [(ngModel)]="appConfig.valueSecond"
                                                        (ngModelChange)="onPassengersValueChange(appConfig)"
                                                        placeholder="distance"
                                                    />
                                                    <input
                                                        type="text"
                                                        [disabled]="appConfig.valueFirst == 0"
                                                        style="width: 48px; text-align: center"
                                                        [(ngModel)]="appConfig.valueUnit"
                                                        (ngModelChange)="onPassengersValueChange(appConfig)"
                                                        placeholder="Unit (e.g. km)"
                                                    />
                                                </div>
                                            </div>
                                        }
                                        @case (appConfigType.enginesForm) {
                                            <div>
                                                Cycles
                                                <mat-slide-toggle [disabled]="!appConfig.enabled" [(ngModel)]="appConfig.value.cycles" />
                                            </div>
                                            <div>
                                                HYD
                                                <mat-slide-toggle [disabled]="!appConfig.enabled" [(ngModel)]="appConfig.value.hydraulics" />
                                            </div>
                                            <div>
                                                TGB,MGB
                                                <mat-slide-toggle [disabled]="!appConfig.enabled" [(ngModel)]="appConfig.value.drivetrain" />
                                            </div>
                                        }
                                        @case (appConfigType.hooks) {
                                            <div>Enable [old simple field]<mat-checkbox [(ngModel)]="appConfig.enabled" /></div>
                                            <small [style.color]="'red'">keep enabled for next fields, simple field will be replaced</small>
                                            <div>
                                                Accessories
                                                <mat-slide-toggle [disabled]="!appConfig.enabled" [(ngModel)]="appConfig.value.accessories" />
                                            </div>
                                            <div>
                                                Cycles
                                                <mat-slide-toggle [disabled]="!appConfig.enabled" [(ngModel)]="appConfig.value.cycles" />
                                            </div>
                                            <div>
                                                Cycles label &nbsp;
                                                <select [(ngModel)]="appConfig.value.label">
                                                    <option value="cycles">cycles</option>
                                                    <option value="openings">openings</option>
                                                </select>
                                            </div>
                                            <div>
                                                Hours
                                                <mat-slide-toggle [disabled]="!appConfig.enabled" [(ngModel)]="appConfig.value.hours" />
                                            </div>
                                            <div>
                                                Inspections
                                                <mat-slide-toggle [disabled]="!appConfig.enabled" [(ngModel)]="appConfig.value.inspections" />
                                            </div>
                                            <div>
                                                Automatic Inspections
                                                <mat-slide-toggle [disabled]="!appConfig.enabled" [(ngModel)]="appConfig.value.automatic" />
                                            </div>
                                        }
                                        @case (appConfigType.hoist) {
                                            <div>
                                                Accessories
                                                <mat-slide-toggle [disabled]="!appConfig.enabled" [(ngModel)]="appConfig.value.accessories" />
                                            </div>
                                            <div>
                                                Cycles
                                                <mat-slide-toggle [disabled]="!appConfig.enabled" [(ngModel)]="appConfig.value.cycles" />
                                            </div>
                                            <div>
                                                Hours
                                                <mat-slide-toggle [disabled]="!appConfig.enabled" [(ngModel)]="appConfig.value.hours" />
                                            </div>
                                            <div>
                                                Inspections
                                                <mat-slide-toggle [disabled]="!appConfig.enabled" [(ngModel)]="appConfig.value.inspections" />
                                            </div>
                                            <div>
                                                Automatic Inspections
                                                <mat-slide-toggle [disabled]="!appConfig.enabled" [(ngModel)]="appConfig.value.automatic" />
                                            </div>
                                        }
                                        @case (appConfigType.flightRefuelLocation) {
                                            <div>
                                                Camo
                                                <mat-slide-toggle [disabled]="!appConfig.enabled" [(ngModel)]="appConfig.value.camo" />
                                            </div>
                                            <div>
                                                Pilot
                                                <mat-slide-toggle [disabled]="!appConfig.enabled" [(ngModel)]="appConfig.value.pilot" />
                                            </div>
                                            <div>
                                                Maintenance
                                                <mat-slide-toggle [disabled]="!appConfig.enabled" [(ngModel)]="appConfig.value.maintenance" />
                                            </div>
                                            <div>
                                                Prefill Next Flights
                                                <mat-slide-toggle [disabled]="!appConfig.enabled" [(ngModel)]="appConfig.value.prefillNextFlights" />
                                            </div>
                                            <div>
                                                Label &nbsp;
                                                <select [(ngModel)]="appConfig.value.label">
                                                    <option value="fuel_depot">Fuel Depot</option>
                                                    <option value="location">Location</option>
                                                </select>
                                            </div>
                                        }
                                        @case (appConfigType.crew) {
                                            <mat-checkbox [(ngModel)]="appConfig.enabled" (ngModelChange)="onCrewValueChange(appConfig)" />
                                            <div>
                                                Daily Prefill
                                                <mat-slide-toggle [disabled]="!appConfig.enabled" [(ngModel)]="appConfig.value.dailyPrefill" />
                                            </div>
                                        }
                                        @case (appConfigType.initialPreviousFlights) {
                                            <div>
                                                <input type="number" style="width: 32px" [(ngModel)]="appConfig.value" min="1" />
                                            </div>
                                        }
                                        @case (appConfigType.pob) {
                                            @if (appConfig.enabled) {
                                                <small [style.color]="'red'">Passengers config is required <br />or this will not work</small>
                                            }
                                        }
                                        @case (appConfigType.enginePowerCheck) {
                                            <div>
                                                Automatic inspection
                                                <mat-slide-toggle [disabled]="!appConfig.enabled" [(ngModel)]="appConfig.value.automatic" />
                                            </div>
                                        }
                                        @case (appConfigType.flightEditing) {
                                            <div style="display: flex; flex-direction: column; align-items: start">
                                                <label>
                                                    HH:MM
                                                    <input
                                                        type="text"
                                                        style="width: 80px"
                                                        [(ngModel)]="appConfig.value.hours"
                                                        [pattern]="HOURS_PATTERN"
                                                        [disabled]="!appConfig.enabled"
                                                    />
                                                </label>
                                            </div>
                                        }
                                        @case (appConfigType.prefillCopilotDirectFlights) {
                                            <div>
                                                Daily Prefill
                                                <mat-slide-toggle [disabled]="!appConfig.enabled" [(ngModel)]="appConfig.value.dailyPrefill" />
                                            </div>
                                        }
                                        @case (appConfigType.oilUnits) {
                                            <div style="margin-bottom: 10px">
                                                ml
                                                <mat-slide-toggle [disabled]="!appConfig.enabled" [(ngModel)]="appConfig.value.ml" />
                                            </div>
                                            <div style="margin-bottom: 10px">
                                                lt
                                                <mat-slide-toggle [disabled]="!appConfig.enabled" [(ngModel)]="appConfig.value.lt" />
                                            </div>
                                            <div>
                                                qt
                                                <mat-slide-toggle [disabled]="!appConfig.enabled" [(ngModel)]="appConfig.value.qt" />
                                            </div>
                                        }
                                        @case (appConfigType.fuelUnits) {
                                            <div style="margin-bottom: 10px">
                                                kg
                                                <mat-slide-toggle [disabled]="!appConfig.enabled" [(ngModel)]="appConfig.value.kg" />
                                            </div>
                                            <div>
                                                lt
                                                <mat-slide-toggle [disabled]="!appConfig.enabled" [(ngModel)]="appConfig.value.lt" />
                                            </div>
                                        }
                                        @case (appConfigType.flightCard) {
                                            <div>
                                                Theme
                                                <select [disabled]="!appConfig.enabled" [(ngModel)]="appConfig.value.theme">
                                                    <option value="default">Default</option>
                                                    <option value="one">One</option>
                                                </select>
                                            </div>
                                        }
                                        @case (appConfigType.warningLongDuration) {
                                            <div>
                                                <label>
                                                    Aircraft
                                                    <input
                                                        type="text"
                                                        style="width: 80px"
                                                        [(ngModel)]="appConfig.value.aircraft"
                                                        [pattern]="HOURS_PATTERN"
                                                        [disabled]="!appConfig.enabled"
                                                        placeholder="HH:MM"
                                                    />
                                                </label>
                                            </div>
                                            <div>
                                                <label>
                                                    Helicopter
                                                    <input
                                                        type="text"
                                                        style="width: 80px"
                                                        [(ngModel)]="appConfig.value.helicopter"
                                                        [pattern]="HOURS_PATTERN"
                                                        [disabled]="!appConfig.enabled"
                                                        placeholder="HH:MM"
                                                    />
                                                </label>
                                            </div>
                                        }
                                        @case (appConfigType.acCycles) {
                                            <div>
                                                Prefill
                                                <mat-slide-toggle [disabled]="!appConfig.enabled" [(ngModel)]="appConfig.value.prefill" />
                                            </div>
                                        }
                                        @case (appConfigType.autoLock) {
                                            <div style="margin-bottom: 10px">
                                                <label>
                                                    Foreground (s)
                                                    <input
                                                        type="number"
                                                        style="width: 64px"
                                                        [(ngModel)]="appConfig.value.foregroundTimeoutSeconds"
                                                        [min]="AUTO_LOCK_LIMITS.foregroundTimeoutSeconds.min"
                                                        [max]="AUTO_LOCK_LIMITS.foregroundTimeoutSeconds.max"
                                                        step="1"
                                                        inputmode="numeric"
                                                        (keydown)="preventNonIntegerKey($event)"
                                                        [disabled]="!appConfig.enabled"
                                                    />
                                                </label>
                                                <small style="display: block"
                                                    >min {{ AUTO_LOCK_LIMITS.foregroundTimeoutSeconds.min }} s · max {{ AUTO_LOCK_LIMITS.foregroundTimeoutSeconds.max }} s</small
                                                >
                                            </div>
                                            <div style="margin-bottom: 10px">
                                                <label>
                                                    Background (s)
                                                    <input
                                                        type="number"
                                                        style="width: 64px"
                                                        [(ngModel)]="appConfig.value.backgroundGraceSeconds"
                                                        [min]="AUTO_LOCK_LIMITS.backgroundGraceSeconds.min"
                                                        [max]="AUTO_LOCK_LIMITS.backgroundGraceSeconds.max"
                                                        step="1"
                                                        inputmode="numeric"
                                                        (keydown)="preventNonIntegerKey($event)"
                                                        [disabled]="!appConfig.enabled"
                                                    />
                                                </label>
                                                <small style="display: block"
                                                    >min {{ AUTO_LOCK_LIMITS.backgroundGraceSeconds.min }} s · max {{ AUTO_LOCK_LIMITS.backgroundGraceSeconds.max }} s</small
                                                >
                                            </div>
                                            <div>
                                                Lock on device lock
                                                <mat-slide-toggle [disabled]="!appConfig.enabled" [(ngModel)]="appConfig.value.lockOnDeviceLock" />
                                            </div>
                                        }
                                    }
                                </div>
                            }
                        </ng-template>
                    </kendo-grid-column>
                }
            </kendo-grid>
        </div>
    </div>
</div>
